import { withInstall } from '@ll-plus/utils'

import Countdown from './src/countdown.vue'

export const LlCountdown = withInstall(Countdown)
export default LlCountdown
export * from './src/countdown'

declare module 'vue' {
  export interface GlobalComponents {
    LlCountdown: typeof Countdown
  }
}
